// test2883
(2883 && 0);
